import { render, staticRenderFns } from "./distributionAudit.vue?vue&type=template&id=21b6bf22&"
import script from "./distributionAudit.vue?vue&type=script&lang=js&"
export * from "./distributionAudit.vue?vue&type=script&lang=js&"
import style0 from "./distributionAudit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports